import React, { useState, useEffect } from 'react';
import NavigationBar from '../NavigationBar';
import axios from '../axios';
import { Container, Row, Col, Table, Button, Badge } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

function PurchaseWaiting() {
    const navigate = useNavigate();
    const [rows, setRows] = useState([]);

    useEffect(() => { fetchData(); }, []);

    const fetchData = async () => {
        try {
            const res = await axios.get(`${window.backendUrl}/purchase_waiting`);
            setRows(res.data.data || []);
        } catch (err) { console.error(err); }
    };

    const markDone = async (activityId) => {
        try {
            await axios.put(`${window.backendUrl}/purchase_activity/${activityId}/done`);
            fetchData();
        } catch (err) { console.error(err); }
    };

    return (
        <>
            <NavigationBar />
            <Container fluid style={{ marginTop: 20 }}>
                <Row className="mb-3"><Col><h3>Waiting for Documents</h3><p className="text-muted">Purchases with an open follow-up logged in their Communication Log.</p></Col></Row>
                <Table striped bordered hover responsive size="sm">
                    <thead>
                        <tr><th>PO No.</th><th>Vendor</th><th>Waiting on</th><th>Follow up by</th><th>Days waiting</th><th></th></tr>
                    </thead>
                    <tbody>
                        {rows.length === 0 ? (
                            <tr><td colSpan={6} className="text-center text-muted" style={{ padding: 20 }}>Nothing waiting right now.</td></tr>
                        ) : rows.map(r => (
                            <tr key={r.ActivityID}>
                                <td style={{ cursor: 'pointer' }} onClick={() => navigate(`/purchase-file/${r.PurchaseID}`)}>{r.PONo}</td>
                                <td>{r.VendorName}</td>
                                <td>{r.LastFollowUp}</td>
                                <td>{r.NextFollowUpDate ? String(r.NextFollowUpDate).slice(0, 10) : '-'}</td>
                                <td>{r.DaysWaiting >= 0 ? <Badge bg={r.DaysWaiting > 7 ? 'danger' : 'warning'} text={r.DaysWaiting > 7 ? undefined : 'dark'}>{r.DaysWaiting}d</Badge> : '-'}</td>
                                <td><Button size="sm" variant="outline-success" onClick={() => markDone(r.ActivityID)}>Mark done</Button></td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Container>
        </>
    );
}

export default PurchaseWaiting;
